import { StateSchema } from 'app/providers/StoreProvider/config/StateSchema';
import { Webinar } from './WebinarsType';

export type VideoType = 'lessons' | 'webinars' | 'streams';

const getLessons = (state: StateSchema) => state?.webinar?.lessons || [];
const getWebinars = (state: StateSchema) => state?.webinar?.webinars || [];
const getStreams = (state: StateSchema) => state?.webinar?.streams || [];

const videoSelector = (
  videoType: VideoType,
): ((state: StateSchema) => Webinar[]) => {
  switch (videoType) {
    case 'lessons':
      return getLessons;
    case 'webinars':
      return getWebinars;
    case 'streams':
      return getStreams;
    default:
      return getLessons;
  }
};

export default videoSelector;
